import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useAuthStore } from '@/stores'

export function useDashboardPage() {
  const { t } = useTranslation('dashboard')
  const navigate = useNavigate()
  const user = useAuthStore((state) => state.user)
  const [bannerDismissed, setBannerDismissed] = useState(false)

  const showSecurityBanner = !bannerDismissed && !!user && !user.twoFactorEnabled

  const dismissBanner = () => setBannerDismissed(true)
  const goToSecuritySettings = () => navigate('/settings?tab=profile')

  return { t, user, showSecurityBanner, dismissBanner, goToSecuritySettings }
}
